import React, { createContext, useState, useContext, useCallback, useMemo, useRef } from 'react';
import { setAnamneseOriginBasico, clearAnamneseOrigin } from '../utils/basicoFlow';
const ModalContext = createContext();
export const useModal = () => useContext(ModalContext) || {};

export const ModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalData, setModalData] = useState(null);
  const [isModalLocked, setIsModalLocked] = useState(false);
  const isModalLockedRef = useRef(false);
  isModalLockedRef.current = isModalLocked;
  const openCountRef = useRef(0);
  const [openCount, setOpenCount] = useState(0);

  const openModal = useCallback((type, data = null) => {
    // Ao abrir entrada genérica de questionário, ajusta flag de origem se aplicável
    try {
      if (type === "modalPesquisa") {
        if (data?.origin === "basico") {
          setAnamneseOriginBasico();
        } else {
          clearAnamneseOrigin();
        }
      }
    } catch {}

    openCountRef.current += 1;
    setOpenCount(openCountRef.current);
    setModalType(type);
    setIsModalOpen(true);
    setModalData(data);
    setIsModalLocked(false);
  }, []);

  const closeModal = useCallback(() => {
    if (isModalLockedRef.current) return;
    setIsModalOpen(false);
    setModalData(null);
    setIsModalLocked(false);
  }, []);

  const setModalLocked = useCallback((locked) => {
    setIsModalLocked(Boolean(locked));
  }, []);

  const value = useMemo(
    () => ({
      isModalOpen,
      modalType,
      modalData,
      openModal,
      closeModal,
      openCount,
      isModalLocked,
      setModalLocked,
    }),
    [isModalOpen, modalType, modalData, openModal, closeModal, openCount, isModalLocked, setModalLocked]
  );

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};
